import { Injectable } from '@angular/core';
import { saveAs } from 'file-saver';
import * as moment from 'moment';
import { GoogleAnalyticsService } from 'src/app/modules/core/services/google/google-analytics.service';
import { environment } from '../../../../../../src/environments/environment';
import { EToastPosition } from '../../enumerables';
import { MiningToastService } from '../mining-toast.service';
import { LanguageService } from '../parameters';

@Injectable({
  providedIn: 'root',
})
export class ExcelExportService {
  constructor(
    private _languageService: LanguageService,
    private _googleAnalyticsService: GoogleAnalyticsService,
    private _toastService: MiningToastService,
  ) {}

  /**
   * Function to export as excel
   *
   * @param data Data to export
   */
  public exportAsExcel(
    data: any,
    excelFileName?: string,
    selectRangeDate?: { startDate: string; endDate: string },
    date?: string,
    isWidget?: boolean,
  ): void {
    //  const format = `${environment.dateFormatSystem} ${environment.timeFormat}`;
    // const date = moment(value.createAt, format).format(`${environment.dateFormatSystem}`);
    const currentDate = moment().format('YYYY-MM-DD');
    let fileName = '';
    let excelDownloadGA = {};
    if (isWidget) {
      fileName = `${this._languageService.message('wdg ').toUpperCase()}${this._languageService.message(excelFileName)} ${currentDate}`;
      excelDownloadGA = {
        widgets: `report_${excelFileName}`,
      };
    } else {
      if (excelFileName === 'report-checklist') {
        fileName = `${this._languageService.message(excelFileName || '')}-${date}`;
      } else {
        fileName = `${this._languageService.message(excelFileName || '')} ${selectRangeDate.startDate || ''} - ${
          selectRangeDate.endDate || ''
        }`;
      }
      excelDownloadGA = {
        report: `${this._languageService.message('rpt_cartir_and_production')}`,
      };
    }
    const blob = new Blob([data], { type: 'application/vnd.ms.excel' });
    const file = new File([blob], `${fileName}.xlsx`, { type: 'application/vnd.ms.excel' });
    saveAs(file);
    this._googleAnalyticsService.sendExcelDownloadEvent(excelDownloadGA);
  }

  /**
   * Function to show toast succes download report
   */
  public messageToastSuccess(): void {
    const downloadReport = this._languageService.message('download-excel-success');
    this._toastService.success(null, downloadReport, {
      position: EToastPosition.bottomCenter,
      closeOnClick: false,
      delay: environment.delayToastSuccess,
    });
  }

  /**
   * Function to show toast error to download report
   */
  public messageToastError(): void {
    const titleToast = this._languageService.message('error-download-title');
    const messageToastError = this._languageService.message('download-excel-error');
    this._toastService.error(titleToast, messageToastError, {
      position: EToastPosition.bottomRight,
      closeOnClick: false,
      delay: environment.delayToastError,
    });
  }
}
